export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/system/pay-message-new/query`,
          data
        });
      },
      // queryByPage (data){
      //     return http.json({
      //         url: '/system/payMessage/queryCharge',
      //         data
      //     });
      // },
      //批量
      batchNotifyPayAndSaveLog(data){
          return http.json({
              url: '/message/log/batchNotifyPayAndSaveLog',
              data
          })
      },
      //单独
      // singleNotifyPayAndSaveLog(houseId){
      //     return http.json({
      //         url: '/message/log/singleNotifyPayAndSaveLog',
      //         params: {
      //             'houseId' : houseId
      //         }
      //     })
      // },
      //批量
      singleNotifyPayAndSaveLog(data){
          return http.json({
              url: '/message/log/singleNotifyPayAndSaveLog',
              data
          })
      },
      //单独
      // singleNotifyPayAndSaveLog(houseId){
      //     return http.json({
      //         url: '/message/log/singleNotifyPayAndSaveLog',
      //         params: {
      //             'houseId' : houseId
      //         }
      //     })
      // },
      //获取待缴费业主信息
      paidOwnerMessage (data){
          return http.json({
              url: '/system/payMessage/query',
              data
          });
      },
      //导出推送记录
      payMessageLogExport(data){
          return http.json({
              url: '/system/payMessageLog/payMessageLogExport',
              data
          })
      },

      //导出推送记录
      tree(data){
          return http.json({
              url: '/windows/village-pay-message/tree',
              data
          })
      },

      /**
       * 获取新视窗待缴费
       * @param data
       * @return {*}
       */
      getPreOrder(data) {
          return http.json({
              url: `/system/pay-message-new/getPreOrder?id=${data}`,
              data
          })
      },

  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/messageDetails.js